import React, {useEffect, useRef, useState} from 'react';
import {
  TransactionSearchOperation,
  TransactionSearchRequest,
} from '../../types';
import { FormattedMessage } from 'react-intl';
import Form from './Form';
import { useAppContext } from '../context/AppContext';
import { ViewContextActions } from '../context/actions/viewContextActions';
import { ViewStateEnum } from '../context/viewStateEnum';
import { searchTransaction } from "../services/public-transaction-searcher-service";
import ReCAPTCHA from "react-google-recaptcha";

type MainViewProps = {
  setTransactionSearchResult: (formData: TransactionSearchOperation) => void;
};

const MainView = ({ setTransactionSearchResult }: MainViewProps) => {
  const {
    viewState,
    viewDispatch,
    transactionSearchRequest,
  } = useAppContext();
  const [formLocks, setFormLocks] = useState(false);
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const [captchaToken, setCaptchaToken] = useState('');
  const { language } = useAppContext();

  useEffect(() => {
    if (
        viewState.state === ViewStateEnum.MAKE_REQUEST &&
        checkThatRequestIsReady(transactionSearchRequest)
    ) {
      viewDispatch({
        type: ViewContextActions.ShowSpinner,
      });
      searchTransaction(transactionSearchRequest, captchaToken)
          .then((result) => {
            result.transactionSearchRequest = transactionSearchRequest;
            setTransactionSearchResult(result);
            setFormLocks(false);
            viewDispatch({
              type: ViewContextActions.ShowResult,
            });
          })
          .catch((error: Error | unknown) => {
            setFormLocks(false);
            viewDispatch({
              type: ViewContextActions.ShowError,
              data: 'errorView.message',
            });
          });
    }
  });

  const checkThatRequestIsReady = (
    transactionSearchRequestData: TransactionSearchRequest,
  ) => {
    return (
      (transactionSearchRequestData.identifier) ||
      (transactionSearchRequestData.email &&
      transactionSearchRequestData.transactionDate !== '' &&
      transactionSearchRequestData.amount !== '' &&
      transactionSearchRequestData.currency !== '' &&
      transactionSearchRequestData.paymentMethod !== '' )
    );
  };

    const handleCaptchaOnSubmit = async () => {
        if (recaptchaRef.current) {
            try {
                const captchaToken = await recaptchaRef.current.executeAsync();
                setCaptchaToken(captchaToken!);

                viewDispatch({
                    type: ViewContextActions.MakeRequest,
                });
            } catch (error) {
                console.error('Error validating captcha token:', error);
                throw error;
            }
        } else {
            viewDispatch({
                type: ViewContextActions.ShowError,
                data: 'captcha.error',
            });
            setFormLocks(false);
        }
    }

  return (
    <main>
      <div className="column column-2">
        <article className="search-form">
          <header className="row">
            <h1>
              <FormattedMessage id="form.header" />
            </h1>
          </header>
            <div className="main">
                <Form
                    handleSubmit={handleCaptchaOnSubmit}
                    formLocks={formLocks}
                />
                <div className="captchaAlign">
                    <div className="captcha">
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY!}
                            hl={language}
                            size="invisible"
                        />
                    </div>
                </div>
            </div>
        </article>
      </div>
    </main>
  );
};

export default MainView;
